import { OnboardingGroup } from '@/bpc/components/OnboardingGroupComponent/OnboardingGroup';
import { SensitiveGoodCategory } from '@mjolnir/mf-fields-ts/src/enm/SensitiveGoodCategory';
import { findFieldByAbsolutePath } from '@/bpc/utils/onboardingGroup';

export const validateHasSensitiveGoods = (group: OnboardingGroup): boolean => {
  const FIELD_PATH = 'sensitive_goods';
  try {
    const field = findFieldByAbsolutePath(group, FIELD_PATH);

    const value = group.getValueForField(FIELD_PATH);
    const validator = field.validator;

    const validationResult =
      validator && !validator.callback(value) ? validator.errorMessage() : undefined;

    const hasSensitiveGoods = value && value !== SensitiveGoodCategory.NONE;

    return !!validationResult || !!hasSensitiveGoods;
  } catch {
    return false;
  }
};
